@if (isUnified) {
  <!-- Unified Code: instructors as cards; the essential details (name, job title, country) are always visible
       instead of the Custom hover panel (criterion 38), each card with a CTA (criterion 28). -->
  <section *ngIf="carouselResize.data.length" class="uc-home-section" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-home-section__header">
        <h2 class="uc-home-section__title uc-display-sm" translate="home.instructors"></h2>
      </div>
      <ul class="uc-card-grid">
        <li *ngFor="let item of carouselResize.data">
          <article class="uc-card uc-entity-card uc-entity-card--person">
            <div class="uc-entity-card__avatar">
              <img loading="lazy" [src]="item.profilePicture ? mediaUrl + item.profilePicture : 'assets/imgs/avatar.jpg'" alt="">
            </div>
            <h3 class="uc-card__title uc-text-lg uc-semibold">
              <a [routerLink]="['/instructor/profile', item.id]" [queryParams]="{isInstructor: true}">{{ isRtl ? item.fullNameAr : item.fullName }}</a>
            </h3>
            <p *ngIf="isRtl ? item.jobTitleAr : item.jobTitle" class="uc-entity-card__subtitle uc-text-sm">{{ isRtl ? item.jobTitleAr : item.jobTitle }}</p>
            <p *ngIf="getInstructorCountry(item.nationalityId)" class="uc-entity-card__meta uc-text-sm">
              <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
              <span>{{ getInstructorCountry(item.nationalityId) }}</span>
            </p>
            <div class="uc-card__actions">
              <a class="btn uc-card__cta" [routerLink]="['/instructor/profile', item.id]" [queryParams]="{isInstructor: true}">
                {{ "unifiedHome.cta.viewProfile" | translate }}
                <span class="visually-hidden">: {{ isRtl ? item.fullNameAr : item.fullName }}</span>
              </a>
            </div>
          </article>
        </li>
      </ul>
    </div>
  </section>
} @else {
<section *ngIf="carouselResize.data.length">
  <div class="container position-relative py-5">
    <h2 class="home-titles position-relative mb-5" translate="home.instructors" [class]="isRtl ? 'text-end' : 'text-start'"></h2>
    <app-custom-carousel #appCustomCarousel [content]="partnersContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event" [showControls]="true" [showIndicators]="true" [distanceStartControlsIndicators]="true"></app-custom-carousel>
    <div (mouseleave)="showInstructor = false" [style]="showInstructor ? 'left: 50%; opacity: 1;' : 'left: 150%; opacity: 0;'" class="instructor-slide d-none d-lg-block">
      <a [routerLink]="['/instructor/profile', currentInstructor.id]" [queryParams]="{isInstructor: true}">
        <div class="instructor-details bg-white">
          <div class="position-relative">
            <div [dir]="isRtl ? 'rtl' : 'ltr'" class="instructor-details-name d-flex align-items-center justify-content-center">
              <span class="name-start">{{firstName}}</span>
              <span class="name-end">{{secondName}}</span>
            </div>
            <div class="p-3 w-100 h-100 d-flex flex-column align-items-center justify-content-center">
              <div class="overflow-hidden rounded-circle mx-auto">
                <img [alt]="isRtl ? currentInstructor.fullNameAr : currentInstructor.fullName" loading="lazy" class="w-100 h-100 object-fit-cover" [src]="currentInstructor.profilePicture ? mediaUrl + currentInstructor.profilePicture : 'assets/imgs/avatar.jpg'">
              </div>
              <h4 class="mb-1">{{isRtl ? currentInstructor.fullNameAr : currentInstructor.fullName}}</h4>
              <span class="instructor-job">{{isRtl ? currentInstructor.jobTitleAr : currentInstructor.jobTitle}}</span>
              <p class="text-center">{{isRtl? currentInstructor.aboutAr : currentInstructor.about}}</p>
              <div *ngIf="getInstructorCountry(currentInstructor.nationalityId)">
                <span>{{getInstructorCountry(currentInstructor.nationalityId)}}</span>
                <i class="fa-solid fa-location-dot"></i>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
  <ng-template #partnersContent>
    <div class="carousel-container w-100 position-relative overflow-hidden">
      <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
        <div class="carousel-slide w-100 h-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
          <div class="row h-100">
            <div class="col text-center h-100" *ngFor="let item of slide">
              <a (mouseenter)="showInstructorSlide(item.id)" [routerLink]="['/instructor/profile', item.id]" [queryParams]="{isInstructor: true}">
                <div class="instructors-card">
                  <div class="overflow-hidden rounded-circle mx-auto">
                    <img [alt]="isRtl ? item.fullNameAr : item.fullName" loading="lazy" class="w-100 h-100 object-fit-cover" [src]="item.profilePicture ? mediaUrl + item.profilePicture : 'assets/imgs/avatar.jpg'">
                  </div>
                  <h4 class="mb-0 pb-1">{{isRtl ? item.fullNameAr : item.fullName}}</h4>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</section>
}
